import CartStorage from '../utils/cartStorage';
import toggleClassModifiers from '../utils/toggleClassModifiers';
import moment from 'moment';
import BaseCheckoutItemsValidator from '../utils/baseCartItemsValidator';
import BaseCartItemRenderer from '../utils/baseCartItemRenderer';
import { objectToUrlParams } from '../utils/urlParams';
import api from '../utils/appApi';
import {__loco} from '../utils/localization';
import {CART_WRAPPER_CLOSE, CART_WRAPPER_OPEN} from "../utils/internalEvents";
import {getUserCurrency} from "../utils/siteSettings";

(function() {
	/**
	 * CartItemsValidator
	 * @extends BaseCheckoutItemsValidator
	 */
	class CartItemsValidator extends BaseCheckoutItemsValidator {
		/**
		 * @inheritDoc
		 */
		constructor() {
			super();
			return this;
		}

		/**
		 * Handle cart validation response
		 *
		 * @param response
		 */
		handleValidationResponse(response) {
			this.renderer.renderItems(this.cartData, response);
		}
	}

	/**
	 * @extends BaseCartItemRenderer
	 */
	class CartItemsRenderer extends BaseCartItemRenderer {
		/**
		 * @inheritDoc
		 */
		constructor() {
			super();
		}

		/**
		 * Render items
		 *
		 * @param {Array|Object} cartData
		 * @param {Object} response
		 */
		renderItems(cartData, response) {
			const parsed = this.parseData(cartData, response.items);
			RenderCartData(parsed);
		}

		/**
		 * Merge old cart data with validated data
		 *
		 * @param cartData
		 * @param items
		 */
		parseData(cartData, items) {
			let parsed = [];

			Object.keys(cartData).forEach(ix => {
				const cartItem = cartData[ix];
				const validated = items[ix];
				parsed[ix] = Object.assign(cartItem, {
					validated: Object.assign(validated, { tour: undefined }),
				});
			});

			return parsed;
		}
	}


	/**
	 * DOM Accessors
	 */
	const cartButton = document.getElementById('cart-button');
	const cartButtonMobile = document.getElementById('cart-button-mobile');
	const cartWrapper = document.getElementById('cart-wrapper');
	const main = document.getElementById('main');
	const body = document.getElementById('body');
	const navbar = document.getElementById('navbar');
	const navbarBlack = document.getElementById('navbar-black');
	const closeButton = document.getElementById('close-button');
	const filledNode = '.cart__filled';
	const filledWrapper = document.getElementById('cart-filled-wrapper');
	const emptyWrapper = null // document.getElementById('cart-empty-wrapper');
	const totalPriceNode = document.getElementById('cart-total-price');
	const menuOverlayForCart = document.getElementById('menuOverlay');

	/**
	 * Logical components
	 */
	const cart = new CartStorage();
	const renderer = new CartItemsRenderer();

	cart.get().then(data => {
		cart.updateCartCount(data);
		updateCartView(data);

	});

	/**
	 * Calculate price for one cart item
	 *
	 * @param {object} data
	 * @returns {number}
	 */
	const calculatePriceForOneItem = data => {
		return Number(parseFloat(data.basket.total_price)).toFixed(2)
	}

	/**
	 * Getting cart item template
	 *
	 * @param {object} data
	 * @returns {string}
	 */
	const getCartItemTemplate = data => {
		// additional checks

		// if(data.status !== undefined && data.status_details !== undefined && data.statrus_details === 'TOUR_NOT_FOUND') {
		// 	return '';
		// }

		// if(data.status !== undefined) {
		/**
		 * Will contain errors list
		 */
		let errors = [];

		const basket = data.basket;

		/**
		 * If validation information for current item exists, render validation errors.
		 */
		if (data.validated !== undefined) {
			/**
			 * Check for price matching errors
			 */
			if (data.validated.price_matching !== undefined && !data.validated.price_matching.status) {
				errors.push(`<div class="cart__item_error">${data.validated.price_matching.message}</div>`);
			}

			/**
			 * Add other errors
			 */
			if (!data.validated.status) {
				errors.push(`<div class="cart__item_error">${data.validated.message}</div>`);
			}
		}

		let startTime = moment(data.start_time, 'HH:mm:ss').format('HH:mm');

		/**
		 * check if an option was added to cart
		 */
		if (data.tour_option_id !== undefined && data.tour_option_time !== undefined) {
			startTime = moment(data.tour_option_time, 'HH:mm:ss').format('HH:mm');
		}

		/**
		 * Override startTime for all day tours
		 */
		if(data.is_all_day_tour) {
			startTime = __loco('Any hour');
		}


		const urlParams = objectToUrlParams({
			// adults: data.adults,
			// children: data.children,
			start_date: basket.date,
			basket: data.basket
		});

		const tourDate = moment(basket.date, 'YYYY-MM-DD').format('ddd, MMM DD');

		// console.log('cart iner data====');
		// console.log(data);

		/**
		 * @todo: Later: Duration checked from selected tour option.
		 * @type {string}
		 */
		const duration = data.duration_time_hour
			? `${data.duration_time_hour} hour${data.duration_time_min ? ` ${data.duration_time_min} minutes / ` : ' / '}`
			: ' ';
		return `
			<div class="cartItem" id="cart-tour-${data.id}">
				<div class="cartItemContainer light-theme">
					<div class="row">
						<div class="col-12">
							<h5 class="subtitle-2 font-weight-medium secondary-text">${data.name}</h5>
						</div>
					</div>
					<div class="row justify-content-between">
						<div class="col-6">
							<p class="cartTourData caption secondary-text">${duration}${basket.tickets_count}  ${__loco('tickets')}</p>
							<p class="cartTourData caption secondary-text">${tourDate}</p>
							<p class="cartTourData caption secondary-text">${startTime}</p>
							${basket.selected_tickets.map(ticket => `
								<p class="cartTourData caption secondary-text">${ticket.ticket.name}: ${ticket.tickets} X ${ticket.ticket.price}${getUserCurrency()}</p>`).join('')}
						</div>
						<div class="col-6">
							<div class="row justify-content-end"><img class="cartItemImage" alt="cart item image" src="${data.photos[0].path_url}"></div>
						</div>
					</div>
					
					<div class="row align-items-center">
					<div class="col-6">
						<div class="row align-items-center">
							<div class="col-auto">
								<a class="cart__item_left-footer__button" href="${data.service_url}${urlParams}#check-availability-section">${__loco('Edit')}</a>
							</div>
							<div class="col-auto pl-0 pr-0">
								<span>|</span>
							</div>
							<div class="col-auto">
								<a class="cart__item_left-footer__button cart-item-remove-btn" data-id="${data.id}">${__loco('Remove')}</a>
							</div>
						</div>
					</div>
					<div class="col-6"><div class="row justify-content-end align-items-center">
						<div class="col-12">
							<p class="cart__item_price-wrapper body-2">${getUserCurrency()} <span class="cart__item_price subtitle-2">${calculatePriceForOneItem(data)}</span></p>
						</div>
					</div></div>
				</div>
				</div>
			</div>
		`
		// return `
		// 		<div class="cart__item" id="cart-tour-${data.id}">
		// 		<div class="cart__item_left">
		// 		  ${errors.length ? `<div class="cart_item__errors">${errors.map(error => error).join('')}</div>` : ''}
		// 		  <div class="cart__item_left-header">
		// 			<p class="cart__item_title">${data.name}</p>
		// 			<p class="cart__item_tour-data">${duration}${basket.tickets_count} ${__loco('tickets')}</p>
		// 			<p class="cart__item_tour-data">${tourDate}</p>
		// 			<p class="cart__item_tour-data">${startTime}</p>
		//
		// 			${basket.selected_tickets.map(ticket => `
		// 				<p class="cart__item_tour-data">${ticket.ticket.name}: ${ticket.tickets} X ${ticket.ticket.price}${getUserCurrency()}</p>
		// 			`).join('')}
		// 		  </div>
		// 		  <div class="cart__item_left-footer">
		// 			<a class="cart__item_left-footer__button" href="${data.service_url}${urlParams}#check-availability-section">${__loco(
		// 	'Edit',
		// )}</a>
		// 			<span>|</span>
		// 			<div class="cart__item_left-footer__button cart-item-remove-btn" data-id="${data.id}">${__loco('Remove')}</div>
		// 		  </div>
		// 		</div>
		// 		<div class="cart__item_right">
		// 		  <div class="cart__item_image-wrapper">
		// 			<img class="cart__item_image" src="${data.photos[0].path_url}">
		// 		  </div>
		// 		  <p class="cart__item_price-wrapper">${getUserCurrency()} <span class="cart__item_price">${calculatePriceForOneItem(data)}</span></p>
		// 		</div>
		// 	  </div>
		// `;
		// }
	};

	/**
	 * Validate cart items
	 *
	 * This will invoke validator, which in its turn will have a renderer assigned, which will render any existing errors
	 */
	const ValidateAfterRender = () => {
		const validator = new CartItemsValidator();
		validator
			.setCart(cart)
			.setRenderer(renderer)
			.cacheCartData();
	};

	/**
	 * Fill cart with items
	 *
	 * @param cartData
	 */
	const RenderCartData = cartData => {
		let price = 0;
		$(filledNode).html('');

		try {
			Object.values(cartData).forEach(itm => {
				price = parseFloat(price) + parseFloat(calculatePriceForOneItem(itm));
				$(filledNode).append(getCartItemTemplate(itm));
			});

			totalPriceNode.innerText = price.toFixed(2);
		} catch (e) {
			const cart = new CartStorage();
			cart.set({});
		}
	};

	/**
	 * Show section
	 *
	 * @param {object} node
	 */
	const showSection = node => {
		for (const section of document.getElementsByClassName('cart__section')) {
			section.classList.add('--hidden');
		}

		node.classList.remove('--hidden');
	};

	/**
	 * Update cart view
	 *
	 * @param {object} data
	 */
	const updateCartView = data => {
		if (Object.values(data).length === 0) {
			showSection(emptyWrapper);
			// reset total price
			totalPriceNode.innerText = '0';
			$('.cart__footer').hide();
			document.getElementById('cart-filled-wrapper').classList.add('d-none')
		} else {
			$('.cart__footer').show();
			showSection(filledWrapper);
			RenderCartData(data);
			document.getElementById('cart-filled-wrapper').classList.remove('d-none')

			/*
			 * Perform validation after cart was initially rendered.
			 * @todo: Currently validation will re-render the cart, which is not the best scenario.
			 *   			Think of a way to implement validation so it would not affect performance.
			 * 				Additionally, a validation request is performed every time the cart is open,
			 * 						which can as well negatively impact performance.
			 */
			ValidateAfterRender();
		}
	};

	/**
	 * Toggles cart wrapper
	 *
	 * @param {boolean} hardOpen
	 */
	const cartToggle = (hardOpen = false) => {
		// console.log('should trigger');

		toggleClassModifiers(
			[
				[cartButton, '--clicked'],
				[cartWrapper, '--active'],
				[main, '--blur'],
				[body, '--overflow-disabled'],
				[navbar || navbarBlack || null, '--border-open'],
			],
			{ add: hardOpen },
		);
		menuOverlayForCart.classList.toggle('showMenuOverlay');

		if (cartWrapper.classList.contains('--active')) {
			cart.get().then(data => updateCartView(data));
		}

		setTimeout(function(){
			if (cartWrapper.classList.contains('--active')) {
				// console.log('has class active');
				$(document).trigger(CART_WRAPPER_OPEN);
			} else {
				$(document).trigger(CART_WRAPPER_CLOSE);
			}
		}, 200);
	};

	/**
	 * Remove item from cart
	 */
	$(document).on('click', '.cart-item-remove-btn', function() {
		const id = $(this).attr('data-id');

		cart.deleteItem(id).then(data => {
			updateCartView(data);
			api.public.catalog.removeFromCookies(id);
			// $(`#cart-tour-${id}`).remove();
		});
	});

	/**
	 * Triggering cart visibility
	 */
	if (cartButton) cartButton.addEventListener('click', cartToggle);
	if (cartButtonMobile) cartButtonMobile.addEventListener('click', cartToggle);
	if (closeButton) closeButton.addEventListener('click', cartToggle);

	document.addEventListener('showCartModal', function(event) {
		event.preventDefault();
		cartToggle(true);
	})

	/**
	 * Open cart when user come from checkout page
	 */
	if (sessionStorage.getItem('cartOpened') === 'true') {
		cartToggle(true);
		sessionStorage.setItem('cartOpened', 'false');
	}
})();
